let pendingRequest = null;

const stopTracks = (stream) => {
  if (!stream || typeof stream.getTracks !== "function") {
    return;
  }
  stream.getTracks().forEach((track) => {
    track.stop();
  });
};

const queryMicrophoneState = async () => {
  if (!navigator.permissions || typeof navigator.permissions.query !== "function") {
    return null;
  }
  try {
    const status = await navigator.permissions.query({ name: "microphone" });
    return status && status.state;
  } catch (error) {
    return null;
  }
};

const requestMicrophone = async () => {
  if (typeof navigator === "undefined") {
    return { granted: false, reason: "unsupported" };
  }

  const permissionState = await queryMicrophoneState();
  if (permissionState === "granted") {
    return { granted: true, reason: "already-granted" };
  }
  if (permissionState === "denied") {
    return { granted: false, reason: "denied" };
  }

  if (!navigator.mediaDevices || typeof navigator.mediaDevices.getUserMedia !== "function") {
    return { granted: false, reason: "unsupported" };
  }

  try {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    stopTracks(stream);
    return { granted: true, reason: "prompt-granted" };
  } catch (error) {
    console.warn("[Arena] Microphone permission request failed", error);
    return { granted: false, reason: "error" };
  }
};

/**
 * Ask for microphone access in the parent page before Arena iframe mounts.
 * Reuses an in-flight request so a click handler and Arena wait on the same prompt.
 */
export const requestMicrophonePermission = () => {
  if (pendingRequest) {
    return pendingRequest;
  }
  pendingRequest = requestMicrophone().finally(() => {
    pendingRequest = null;
  });
  return pendingRequest;
};
